



























import VueOptions from '@utils/VueOptions'
import ShoppingCartItemCard from '@ui/cards/ShoppingCartItemCard'
import OverrideCreditOrderPayoutTriggerModal from '@triggers/CheckoutWizard/OverrideCreditOrderPayoutTriggerModal'
import ShoppingCartLineItemResourceList from '@superComponents/ShoppingCart/ShoppingCartLineItemResourceList'

settings =
  name: 'ShoppingCartCardView'

  vue:
    props: ['lineItems', 'campaign', 'activationPlans', 'actions', 'options']

    components: {
      ShoppingCartLineItemResourceList,
      ShoppingCartItemCard,
      OverrideCreditOrderPayoutTriggerModal,
    }

    computed:
      lineItemsByListing: ->
        listings = {}
        for lineItem in @lineItems
          l = @ctxAudienceListing lineItem
          key = "#{l.id}:#{lineItem.space_name}"
          listings[key] ||= []
          listings[key].push lineItem
        Object.values(listings)

      # lineItemsByEvent: ->
      #   events = {}
      #   for lineItem in @lineItems
      #     ev = @eventForLineItem(lineItem)
      #     events[ev.id] ||= []
      #     events[ev.id].push lineItem
      #   Object.values(events)

      isSavedItem: -> @options?.savedItemsList
      enabledActions: -> @options?.enabledActions
      emptyMessage: -> @options?.emptyMessage || 'Your cart is empty'

      actionsForShoppingCartItemCard: ->
        actions =
          fetchResource: @actions.fetchResource
          updateQuantityTrigger: @actions.updateQuantityTrigger
          removeAudienceListingFromCartTrigger: @actions.removeAudienceListingFromCartTrigger
          refreshCartListingTrigger: @actions.refreshCartListingTrigger
          hiSaveForLaterTrigger: @actions.hiSaveForLaterTrigger
          hiMoveToCartTrigger: @actions.hiMoveToCartTrigger
          hiEditLineItemsForEvent: @actions.hiEditLineItemsForEvent
          favoriteEventTrigger: @actions.favoriteEventTrigger
          unfavoriteEventTrigger: @actions.unfavoriteEventTrigger

        if (@currentMemberIsSuperUser())
          actions['updateOriginalPriceTrigger'] = @actions.updateOriginalPriceTrigger
          actions['updateOriginalPayoutTrigger'] = @actions.updateOriginalPayoutTrigger
          actions['updateLineItemDiscountTrigger'] = @actions.updateLineItemDiscountTrigger

        actions

    methods:
      eventForLineItem: (lineItem)-> @ctxEvent lineItem
      overridePurchaseCreditOrderPayout: (lineItem) ->
        @$refs.overridePurchaseCreditOrderPayout.fire()
      onCartAddCreditDiscount: ->
        @fetch('cart')
        @$refs.overridePurchaseCreditOrderPayout.close()

export default VueOptions.vue settings
